import { render } from "./index.vue?vue&type=template&id=b2925e3e&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=b2925e3e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b2925e3e"

export default script